var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.67,
    height: 26.637,
    viewBox: "0 0 20.67 26.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-reports",
    transform: "translate(-2.833 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M71.173,25.761h-5.35v-.823h3.292a.823.823,0,0,0,.823-.823V22.469a.823.823,0,0,0-.823-.823H65.823V20.412a.412.412,0,1,0-.823,0V34.4a.412.412,0,1,0,.823,0V33.168h3.292a.823.823,0,0,0,.823-.823V30.7a.823.823,0,0,0-.823-.823H65.823v-.823h5.35A.823.823,0,0,0,72,28.23V26.584A.823.823,0,0,0,71.173,25.761Zm-5.35-3.292h3.292v1.646H65.823Zm3.292,8.23v1.646H65.823V30.7Zm2.058-2.469h-5.35V26.584h5.35Z",
    transform: "translate(-51.626 -15.885)",
    fill: "#696969",
    stroke: "#696969",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M28.412,105.823h4.527a.412.412,0,1,0,0-.823H28.412a.412.412,0,1,0,0,.823Z",
    transform: "translate(-22.239 -83.396)",
    fill: "#696969",
    stroke: "#696969",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M35,113H28.412a.412.412,0,1,0,0,.823H35A.412.412,0,1,0,35,113Z",
    transform: "translate(-22.239 -89.75)",
    fill: "#696969",
    stroke: "#696969",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M34.87,24.279V2.058A2.06,2.06,0,0,0,32.812,0H19.13a.823.823,0,0,0-.582.241L14.741,4.048a.823.823,0,0,0-.241.582v19.65a2.06,2.06,0,0,0,2.058,2.058H32.812A2.06,2.06,0,0,0,34.87,24.279ZM19.13.823V3.395A1.236,1.236,0,0,1,17.895,4.63H15.323ZM34.047,24.279a1.236,1.236,0,0,1-1.235,1.235H16.558a1.236,1.236,0,0,1-1.235-1.235V5.453h2.572a2.06,2.06,0,0,0,2.058-2.058V.823h12.86a1.236,1.236,0,0,1,1.235,1.235Z",
    transform: "translate(-11.517)",
    fill: "#696969",
    stroke: "#696969",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M38.761,36.308v-.837a6.184,6.184,0,0,1-4.923-5.636h4.923v-.823H33.838a6.139,6.139,0,0,1,1.211-3.277l3.712,3.174V27.827l-3.176-2.716a6.17,6.17,0,0,1,3.176-1.735v-.837A7,7,0,0,0,34.7,24.854c-.008.008-.017.015-.025.024s-.011.017-.017.025a6.988,6.988,0,0,0,4.1,11.405Z",
    transform: "translate(-26.21 -17.901)",
    fill: "#696969",
    stroke: "#696969",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.84855f6bc5d92fcd78358d70b7591d8d.svg";
export { ForwardRef as ReactComponent };